const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '')

const getApiFileBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  if (apiUrl.endsWith('/api')) {
    return apiUrl.substring(0, apiUrl.length - 4)
  }

  return 'https://api.aisenseus.net'
}

export const toAbsoluteUrl = (pathname: string) => `${publicUrl}${pathname}`

const defaultSidebarLogo = '/media/logos/aisenseus-logo-21-landscape-white.webp'

export const resolveCompanyLogoUrl = (companyLogo?: string | null) => {
  if (!companyLogo) {
    return toAbsoluteUrl(defaultSidebarLogo)
  }

  const trimmed = companyLogo.trim()
  if (!trimmed) {
    return toAbsoluteUrl(defaultSidebarLogo)
  }

  if (/^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?\//i.test(trimmed)) {
    const pathMatch = trimmed.match(/\/files\/avatars\/.+$/i)
    if (pathMatch) {
      return `${getApiFileBaseUrl()}${pathMatch[0]}`
    }

    return toAbsoluteUrl(defaultSidebarLogo)
  }

  return trimmed
}
